import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Nav from './nav';
import Header from './hero-components/header';
import MobileDraft from './low-resolution-components/mobile-draft';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export default function LowResolutionView({ type, mobileImageUrl }) {
  return (
    <>
      <Nav active={type} />
      <Container>
        <Header name={`${type} report`} />
        <MobileDraft mobileImageUrl={mobileImageUrl} />
      </Container>
    </>
  );
}

LowResolutionView.propTypes = {
  type: PropTypes.oneOf(['performance', 'audience']).isRequired,
  mobileImageUrl: PropTypes.string.isRequired,
};
